import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { scrollToOffset } from '@opten/scroll/scroll-to-offset';
import { PageRenderHelper } from './page-render-helper';

@Component({ className: 'js-tabs' })
export class TabsComponent {
	items: HTMLElement[];
	innerContent: HTMLElement;

	constructor(private element: HTMLElement) {
		this.items = Array.from(
			this.element.querySelectorAll('.js-tab-item')
		) as HTMLElement[];
		this.innerContent = this.element.querySelector(
			'.js-tab-inner'
		) as HTMLElement;

		const pageRenderHelper = new PageRenderHelper(
			this.innerContent,
			'.js-tab-inner'
		);

		this.items.forEach(item => {
			item.addEventListener('click', e => {
				e.preventDefault();

				scrollToOffset(this.innerContent.getBoundingClientRect().top - 150);

				setTimeout(() => {
					this.items.forEach(o => removeClass(o, 'is-active'));
					addClass(item, 'is-active');

					const url = item.getAttribute('data-url');
					pageRenderHelper
						.fetch(url)
						.then(newContent => {})
						.catch(error => {})
						.finally(() => {});
				}, 500);
			});
		});
	}
}
